// extracted by mini-css-extract-plugin
export default {"ContractId":"_ContractId--n80a1"};